import { mapGetters } from 'vuex'
import { crmSettingRecordListAPI } from '@/api/customer/common'

export default {
	data() {
		return {
			/** 记录类型 */
			followTypes: [],
			followType: '',
			
			followTypes1: [
				{"type":"已报价","name":"已报价"},
				{"type":"未报价","name":"未报价"}
			],
			followType1: '',
			
			followTypes2: [
				{"type":"一星","name":"一星"},
				{"type":"二星","name":"二星"},
				{"type":"三星","name":"三星"}
			],
			followType2: ''
		}
	},

	computed: {
		...mapGetters([
			'allAuth'
		]),
		showOAPermission() {
			return this.allAuth
		}
	},

	created() {
		this.getFollowLogType()
	},

	methods: {
		/**
		 * 获取详情
		 */
		getFollowLogType() {
			this.loading = true
			crmSettingRecordListAPI()
				.then(res => {
					this.loading = false
					this.followTypes = res.data.map(item => {
						return {
							type: item,
							name: item
						}
					})
					// this.followType = res.data.length > 0 ? res.data[0] : ''
				})
				.catch(() => {
					this.loading = false
				})
		}
	},

	deactivated: function() {}

}
